// 国际机票
const state = {
  searchParams: {}, // 查询参数,
  orderFillParams: {}, // 订单填写参数
  orderConfirmParams: {}, // 订单确认参数
  lowPrices: {} // 低价信息
}
const getters = {
  internationalParams: state => state.searchParams,
  internationalOrderFillParams: state => state.orderFillParams,
  internationalOrderConfirmParams: state => state.orderConfirmParams,
  internationalLowPrices: state => state.lowPrices
}
const mutations = {
  setInternationalSearchParams (state, data) {
    state.searchParams = data || {}
  },
  setInternationalOrderFillParams (state, data) {
    state.orderFillParams = data || {}
  },
  setInternationalOrderConfirmParams (state, data) {
    state.orderConfirmParams = data || {}
  },
  setInternationalLowPrices (state, data) {
    state.lowPrices = data || {}
  }
}
export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/internationalStore.js